var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
import dayjs from "dayjs";
function handleError({
  ctx,
  errorClass,
  handler,
  error
}) {
  console.error(`${dayjs().format("YYYY-MM-DD HH:mm:ss.SSS")}	`, error);
  if (typeof handler === "function" && error instanceof errorClass) {
    handler.call(null, error, ctx);
  } else {
    throw error;
  }
}
__name(handleError, "handleError");
const Factory = /* @__PURE__ */ __name(({ errorClass, handler }) => {
  return (_target, _propertyKey, descriptor) => {
    const originalMethod = descriptor.value;
    descriptor.value = function(...args) {
      try {
        const result = originalMethod.apply(this, args);
        if (result && typeof result.then === "function" && typeof result.catch === "function") {
          return result.catch((error) => {
            handleError({ ctx: this, errorClass, handler, error });
          });
        }
        return result;
      } catch (error) {
        handleError({ ctx: this, errorClass, handler, error });
        return void 0;
      }
    };
    return descriptor;
  };
}, "Factory");
const Catch = /* @__PURE__ */ __name((handler) => Factory({ errorClass: Error, handler }), "Catch");
const CatchEx = /* @__PURE__ */ __name((errorClass, handler) => Factory({ errorClass, handler }), "CatchEx");
const LogError = /* @__PURE__ */ __name(() => Catch((_error, _ctx) => {
}), "LogError");
export {
  Catch,
  CatchEx,
  LogError
};
//# sourceMappingURL=try-catch-decorator.js.map
